module.exports = __webpack_public_path__ + "static/media/watchlist-black.79791aa7.svg";